export default "__VITE_ASSET__70d972b0__"